// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feed-card-enter-active[data-v-a1270710],.feed-card-leave-active[data-v-a1270710]{transition:opacity .2s ease,transform .2s ease}.feed-card-enter[data-v-a1270710],.feed-card-leave-to[data-v-a1270710]{opacity:0;transform:translateY(.5rem)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
